document.addEventListener('DOMContentLoaded', function() {
$(".cust-logo-slider").slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  centerMode: true,
  arrows: false, 
  centerPadding: '60px', // Optional: adjust padding around center slide
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        centerPadding: '20px'
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        centerPadding: '10px'
      }
    }
  ]
});


// $(".cust-testi-slider").slick({
//   slidesToShow: 3,
//   infinite: true,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 2000,
//   dots: true, Boolean,
//   prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0935/3642/0125/files/Group_1000008019_1.png?v=1745487327"></button>',
//   nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0935/3642/0125/files/Group_1000008018_1.png?v=1745487328"></button>',
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });

function setEqualSlideHeights() {
  let maxHeight = 0;

  // Reset all slide content heights before recalculating
  $(".cust-testi-slider .cust-textibox").css("height", "auto");

  // Find max height among all slides' .cust-textibox elements (including clones)
  $(".cust-testi-slider .slick-slide").each(function () {
    const box = $(this).find(".cust-textibox");
    if (box.length) {
      const h = box.outerHeight();
      if (h > maxHeight) maxHeight = h;
    }
  });
  // console.log(`Max height to set: ${maxHeight}px`);

  // Set all .cust-textibox heights to maxHeight
  $(".cust-testi-slider .cust-textibox").css("height", maxHeight + "px");
}

$(".cust-testi-slider").slick({
  slidesToShow: 3,
  infinite: true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: true,
  prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0935/3642/0125/files/Group_1000008019_1.png?v=1745487327"></button>',
  nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0935/3642/0125/files/Group_1000008018_1.png?v=1745487328"></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// Run height adjustment on slider init, after each reposition, and window resize
$(".cust-testi-slider").on("init", function () {
  setEqualSlideHeights();
});
$(".cust-testi-slider").on("setPosition", function () {
  setEqualSlideHeights();
});
$(window).on("resize", function () {
  setEqualSlideHeights();
});


$(".our-journey-slider").slick({
  slidesToShow: 5,
  infinite: false,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 1200, 
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 992, 
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768, 
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 576, 
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

document.querySelectorAll('.cust-monthly-charge a').forEach(function(anchor) {
  anchor.addEventListener('click', function() {
    var productInfo = anchor.closest('.product__info-wrapper');
    if (productInfo) {
      var priceElement = productInfo.querySelector('.price-item--regular');
      if (priceElement) {
        var productPrice = priceElement.textContent.trim().replace(/\s+/g, '');
        console.log(productPrice);
        var input = document.getElementById('purchase-price');
        if (input) {
          input.value = productPrice;
        }
      }
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cust-monthly-charge a').forEach(function(anchor) {
    var productInfo = anchor.closest('.product__info-wrapper');
    if (productInfo) {
      var priceElement = productInfo.querySelector('.price-item--regular');
      if (priceElement) {
        var productPrice = priceElement.textContent.trim().replace(/\s+/g, '');
        console.log(productPrice);
        var input = document.getElementById('purchase-price');
        if (input) {
          input.value = productPrice;
        }
      }
    }
  });
});

// =============================================
// LBG Click-to-Call Meta Pixel Tracking
// Added: April 2026
// Fires Contact event on 2nd click of #callToggleBtn
// (when phone number is already revealed = call intent)
// =============================================
document.addEventListener('DOMContentLoaded', function () {
  var callBtn = document.getElementById('callToggleBtn');
  if (!callBtn) return; // Only runs on pages with the call button

  callBtn.addEventListener('click', function () {
    // The button starts as "Call or Text For More"
    // After 1st click it shows the phone number (e.g. "302-644-5558")
    // The 2nd click (when text = data-number) is the call intent we track
    var phoneNumber = this.getAttribute('data-number');
    if (this.textContent.trim() === phoneNumber) {
      if (typeof fbq !== 'undefined') {
        fbq('track', 'Contact', {
          content_name: 'Phone Call Click',
          content_category: 'Phone',
          content_ids: [phoneNumber]
        });
      }
    }
  });
});

document.addEventListener('click', function (e) {
const btn = e.target.closest('.loadmore-event button');
if(btn){
  const container = document.querySelector('.ctct_eventwidget');
  const isExpanded = container.classList.toggle('show-all');
  btn.textContent = isExpanded ? 'Show Less' : 'Load More';
}
});
document.addEventListener('click', function (e) {
const btn = e.target.closest('.loadmore-event-new button');
if(btn){
  const container = document.querySelector('.main-event-inner-container');
  const isExpanded = container.classList.toggle('show-all');
  btn.textContent = isExpanded ? 'Show Less' : 'Load More';
  if(!isExpanded){
  document.querySelector(".main-event-container").scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
  }
}
});
});

// =============================================
// LBG PDP Attribution Persistence + Virtual Number Tracking
// Added: July 2026
// =============================================
(function () {
  var STORAGE_KEY = 'lbg_attribution_v1';
  var SESSION_KEY = 'lbg_session_id_v1';
  var ATTR_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'msclkid', 'ad_campaign_id'];

  function safeJsonParse(value) {
    try { return value ? JSON.parse(value) : null; } catch (e) { return null; }
  }

  function safeStorageGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function safeStorageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'lbg-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function getSessionId() {
    var sid = safeStorageGet(SESSION_KEY);
    if (!sid) {
      sid = uuid();
      safeStorageSet(SESSION_KEY, sid);
    }
    return sid;
  }

  function queryData() {
    var params = new URLSearchParams(window.location.search || '');
    var out = {};
    ATTR_PARAMS.forEach(function (key) {
      var value = params.get(key);
      if (value) out[key] = value;
    });
    return out;
  }

  function pageData() {
    return {
      landing_page_url: window.location.href,
      landing_page_path: window.location.pathname,
      landing_page_query: window.location.search || '',
      referrer: document.referrer || '',
      captured_at: new Date().toISOString()
    };
  }

  function productData() {
    var title = document.querySelector('h1, .product__title, [data-product-title]');
    var productHandle = document.querySelector('form.cust_form input#product');
    var hni = document.querySelector('form.cust_form input#HNI');
    var boatModel = document.querySelector('form.cust_form input#boat_model');
    var price = document.querySelector('form.cust_form input#boat_list_price');
    return {
      product_title: title ? title.textContent.trim() : document.title,
      product_handle: productHandle ? productHandle.value : '',
      hni: hni ? hni.value : '',
      boat_model: boatModel ? boatModel.value : '',
      boat_list_price: price ? price.value : ''
    };
  }

  function capture() {
    var stored = safeJsonParse(safeStorageGet(STORAGE_KEY)) || {};
    var current = queryData();
    var hasCurrent = Object.keys(current).length > 0;
    var now = Object.assign({}, pageData(), current);
    var data = {
      session_id: getSessionId(),
      first_touch: stored.first_touch || now,
      last_touch: hasCurrent ? now : (stored.last_touch || now)
    };
    safeStorageSet(STORAGE_KEY, JSON.stringify(data));
    return data;
  }

  function attribution() {
    return safeJsonParse(safeStorageGet(STORAGE_KEY)) || capture();
  }

  function setField(form, nameOrId, value) {
    if (value == null) value = '';
    var field = form.querySelector('[name="' + nameOrId + '"], #' + nameOrId);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = nameOrId;
      field.id = nameOrId;
      form.appendChild(field);
    }
    field.value = String(value);
  }

  function commentsPayload(attr) {
    var last = attr.last_touch || {};
    var first = attr.first_touch || {};
    return [
      'LBG Website Attribution',
      'Session ID: ' + (attr.session_id || ''),
      'Last Touch Source: ' + (last.utm_source || ''),
      'Last Touch Medium: ' + (last.utm_medium || ''),
      'Last Touch Campaign: ' + (last.utm_campaign || ''),
      'Last Touch Content: ' + (last.utm_content || ''),
      'Last Touch Term: ' + (last.utm_term || ''),
      'GCLID: ' + (last.gclid || ''),
      'FBCLID: ' + (last.fbclid || ''),
      'MSCLKID: ' + (last.msclkid || ''),
      'Ad Campaign ID: ' + (last.ad_campaign_id || ''),
      'First Touch Source: ' + (first.utm_source || ''),
      'Landing Page: ' + (first.landing_page_url || last.landing_page_url || ''),
      'Current Page: ' + window.location.href,
      'Referrer: ' + (first.referrer || last.referrer || '')
    ].join('\n');
  }

  function normalizeSourceForCrm(source, first, last) {
    var normalized = String(source || '').trim().toLowerCase();
    var metaAliases = ['fb', 'ig', 'instagram', 'meta'];
    if (metaAliases.indexOf(normalized) !== -1) return 'facebook';
    if (!normalized && ((last && last.fbclid) || (first && first.fbclid))) return 'facebook';
    return source || '';
  }

  function fillForms() {
    var attr = attribution();
    var first = attr.first_touch || {};
    var last = attr.last_touch || {};
    var sourceForCrm = normalizeSourceForCrm(last.utm_source || first.utm_source || '', first, last);
    document.querySelectorAll('form.cust_form').forEach(function (form) {
      setField(form, 'utm_source', sourceForCrm);
      setField(form, 'utm_medium', last.utm_medium || first.utm_medium || '');
      setField(form, 'utm_campaign', last.utm_campaign || first.utm_campaign || '');
      setField(form, 'utm_content', last.utm_content || first.utm_content || '');
      setField(form, 'utm_term', last.utm_term || first.utm_term || '');
      setField(form, 'ad_campaign_id', last.ad_campaign_id || first.ad_campaign_id || '');
      setField(form, 'gclid', last.gclid || first.gclid || '');
      setField(form, 'fbclid', last.fbclid || first.fbclid || '');
      setField(form, 'msclkid', last.msclkid || first.msclkid || '');
      setField(form, 'landing_page_url', first.landing_page_url || last.landing_page_url || window.location.href);
      setField(form, 'landing_page_path', first.landing_page_path || last.landing_page_path || window.location.pathname);
      setField(form, 'landing_page_query', first.landing_page_query || last.landing_page_query || window.location.search || '');
      setField(form, 'txtReferralURL', first.referrer || last.referrer || document.referrer || '');
      setField(form, 'attribution_session_id', attr.session_id || '');
      setField(form, 'first_touch_json', JSON.stringify(first));
      setField(form, 'last_touch_json', JSON.stringify(last));
      setField(form, 'txtLeadCommentsAppend', commentsPayload(attr));
      setField(form, 'txtLeadDesc', commentsPayload(attr));
    });
  }

  var PHONE_ATTRIBUTION_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/22794968/4ua2k4y/';

  function postPhoneAttribution(payload) {
    if (!PHONE_ATTRIBUTION_WEBHOOK_URL) return;
    try {
      var form = new URLSearchParams();
      Object.keys(payload || {}).forEach(function (key) {
        var value = payload[key];
        if (value == null) value = '';
        if (typeof value === 'object') value = JSON.stringify(value);
        form.append(key, String(value));
      });
      form.append('payload_json', JSON.stringify(payload || {}));
      fetch(PHONE_ATTRIBUTION_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: form.toString(),
        keepalive: true,
        mode: 'no-cors'
      }).catch(function () {
        try {
          if (navigator.sendBeacon) navigator.sendBeacon(PHONE_ATTRIBUTION_WEBHOOK_URL, form);
        } catch (ignore) {}
      });
    } catch (e) {}
  }

  function publish(name, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    if (name === 'lbg_virtual_number_click') postPhoneAttribution(payload);
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish(name, payload); } catch (e) {}
    }
  }

  function phoneDigits(value) {
    return String(value || '').replace(/\D/g, '').slice(-10);
  }

  function phoneValue(element) {
    if (!element) return '';
    var href = element.getAttribute('href') || '';
    var hrefValue = href.replace(/^(?:tel|sms):/i, '').split('?')[0];
    return element.getAttribute('data-number') || hrefValue || element.textContent.trim();
  }

  function phonePayload(button, action) {
    var attr = attribution();
    var timestamp = new Date().toISOString();
    return Object.assign({
      interaction_type: 'virtual_number_click',
      cta_action: action,
      phone_event_id: (attr.session_id || getSessionId()) + ':' + Date.now() + ':' + action,
      displayed_virtual_number: phoneValue(button),
      page_url: window.location.href,
      timestamp: timestamp
    }, productData(), attr);
  }

  var ALLOWED_VIRTUAL_NUMBER = '3026445558';
  var lastPhoneEventKey = '';
  var lastPhoneEventAt = 0;

  function publishPhoneEvent(element, action) {
    var digits = phoneDigits(phoneValue(element));
    if (digits !== ALLOWED_VIRTUAL_NUMBER) return false;

    var now = Date.now();
    var key = action + ':' + digits + ':' + window.location.pathname;
    if (key === lastPhoneEventKey && now - lastPhoneEventAt < 1000) return false;

    lastPhoneEventKey = key;
    lastPhoneEventAt = now;
    publish('lbg_virtual_number_click', phonePayload(element, action));
    return true;
  }

  capture();
  window.LBGAttribution = {
    capture: capture,
    get: attribution,
    fillForms: fillForms,
    phonePayload: phonePayload
  };

  document.addEventListener('DOMContentLoaded', function () {
    fillForms();

    var callBtn = document.getElementById('callToggleBtn');
    if (callBtn) {
      callBtn.addEventListener('click', function () {
        var phoneNumber = callBtn.getAttribute('data-number') || '';
        var isDialIntent = callBtn.textContent.trim() === phoneNumber;
        publishPhoneEvent(callBtn, isDialIntent ? 'dial_intent' : 'reveal_number');
      }, true);
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('a[href]') : null;
      if (!link || link.id === 'callToggleBtn') return;

      var href = link.getAttribute('href') || '';
      if (!/^(?:tel|sms):/i.test(href)) return;

      publishPhoneEvent(link, /^sms:/i.test(href) ? 'text_intent' : 'dial_intent');
    }, true);
  });
})();
